<template>
  <div class="advform ops-form-date ops-date-input">

    <!-- From element -->
    <div class="uk-grid-small" uk-grid>

      <!-- Header -->
      <div class="uk-container-expand">
        <span class="uk-label uk-margin-right">{{inputelement.chLibs}}</span>
        <div uk-form-custom="target: > * > span:first-child">
          <select v-model="selected" @change="changeType">
            <option value="D">Egal à</option>
            <option value="CDLT">Inférieur à</option>
            <option value="CDGT">Superieur à</option>
            <option value="Dcompris">Compris entre</option>
          </select>
          <button class="uk-button uk-button-small uk-button-default" type="button" tabindex="-1">
            <span></span>
            <span class="uk-margin-small-left" uk-icon="icon: chevron-down ; ratio: 0.5"></span>
          </button>
        </div>
      </div>
      <!-- END Header -->

      <div class="uk-inline uk-width-expand@m">
        <div class="uk-inline uk-width-expand@m">
          <vue-tags-input
            ref="tagsInput"
            v-model="tag"
            :tags="tags"
            :max-tags="1"
            :allow-edit-tags="true"
            :placeholder="tags.length === 0 ? inputelement.placeholder : ''"
            :add-on-key-press="tags.length === 0"
            @tags-changed="handleTagsChanged"
            @before-adding-tag="(obj) => handleTagAction('add', obj, 'chValues')"
            @before-deleting-tag="(obj) => handleTagAction('delete', obj, 'chValues')"
          />
        </div>
        <flat-pickr
          v-model="date"
          :config="config.start"
          class="form-control uk-input datepicker-input"
          :placeholder=inputelement.placeholder
          name="date"
          @focusout="emitSaveFieldValue(inputelement)"
          @on-change="onChangeDatepicker1">
        </flat-pickr>
        <a class="uk-form-icon uk-form-icon-flip" href="#" uk-icon="icon: m_date_range" data-toggle></a>
      </div>

      <div v-if="selected == 'Dcompris'" class="uk-inline uk-width-auto uk-text-center">
        <span class="round-et uk-background-secondary">ET</span>
      </div>

      <div v-if="selected == 'Dcompris'" class="uk-inline uk-width-expand@m">
        <div class="uk-inline uk-width-expand@m">
          <vue-tags-input
            ref="tagsInput"
            v-model="tag2"
            :tags="tags2"
            :max-tags="1"
            :allow-edit-tags="true"
            :placeholder="tags2.length === 0 ? inputelement.placeholder : ''"
            :add-on-key-press="tags2.length === 0"
            @tags-changed="handleTags2Changed"
            @before-adding-tag="(obj) => handleTagAction('add', obj, 'chValues2')"
            @before-deleting-tag="(obj) => handleTagAction('delete', obj, 'chValues2')"
          />
        </div>
        <flat-pickr
          v-model="date2"
          :config="config.end"
          class="input-group form-control uk-input datepicker-input"
          :placeholder=inputelement.placeholder
          name="date2"
          @on-change="onChangeDatepicker2"
          @focusout="emitSaveFieldValue(inputelement)">
        </flat-pickr>
        <a class="uk-form-icon uk-form-icon-flip" href="#" uk-icon="icon: m_date_range" data-toggle></a>
      </div>

      <div class="menu uk-width-auto@m">
        <i
          class="deleteFormCritere"
          @click="deleteFormCritere"
          uk-icon="icon: minus-circle; ratio: 1.5"></i>
      </div>
    </div>
    <!-- END From element -->

  </div>
</template>

<script>

// Import FOR TAG
import { VueTagsInput } from '@johmun/vue-tags-input'

// Import FOR DATEPIKER
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
// theme is optional
import { French } from 'flatpickr/dist/l10n/fr.js'

import { mapActions } from 'vuex'
require('@/assets/css/inablue.css')

export default {
  name: 'InputAutoDate',
  props: ['inputelement'],
  components: {
    flatPickr,
    VueTagsInput
  },
  data () {
    return {
      tag: '',
      tag2: '',
      tags: (this.inputelement.hasOwnProperty('chValues') && this.inputelement.chValues !== '') ? [{"text": this.inputelement.chValues }] : [],
      tags2: (this.inputelement.hasOwnProperty('chValues2') && this.inputelement.chValues2 !== '') ? [{"text": this.inputelement.chValues2 }] : [],
      tagJson: [],
      hasJustAddedTag: false, // Nouvel état pour gérer l'ajout de tags

      // Initial value
      date: this.inputelement.hasOwnProperty('chValues') ? this.inputelement.chValues : [],
      date2: this.inputelement.hasOwnProperty('chValues2') ? this.inputelement.chValues2 : [],

      // Get more form https://chmln.github.io/flatpickr/options/
      config: {
        start: {
          allowInput: true, // Permet la saisie manuelle dans l'input
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'd/m/Y', // format 06/09/2024
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: French, // locale for this instance only
          minDate: null,
          maxDate: new Date(),
          clickOpens: false // Empêche l'ouverture automatique du date picker
        },
        end: {
          allowInput: true,
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'd/m/Y', // format 06/09/2024
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: French, // locale for this instance only
          minDate: null,
          maxDate: new Date(),
          clickOpens: false // Empêche l'ouverture automatique du second date picker
        }

      },

      selected: this.inputelement.chValues2 ? 'Dcompris' : this.inputelement.chTypes,
      // haveIndexIframe: this.inputelement.hasOwnProperty('index')
      haveIndexIframe: false,
      previousDate1: '',
      previousDate2: ''
    }
  },
  mounted() {
    const inputElement = this.$refs.tagsInput.$el.querySelector('input')
    if (inputElement) {
      inputElement.addEventListener('keyup', this.handleEnterKey)
    }
  },
  methods: {
    ...mapActions([
      'emitSaveFieldValue',
      'emitCleanRequeteNode',
      'emitClearFormEnded'
    ]),
    created: function () {
      var bc = new BroadcastChannel('preview:compiled')
      bc.onmessage = function (message) {
        console.log(message.data)
      }
    },
    deleteFormCritere () {
      this.$emit('deleteCritere', this.inputelement)
    },
    convertDateYmdTodmy (dateStr) {
      const [year, month, day] = dateStr.split('-')
      return `${day}/${month}/${year}`
    },
    getBoundedDate(input, isStart = true) {
      if (!input || typeof input !== 'string') return null

      input = input.trim()

      // Format FR (dd/mm/yyyy)
      const matchFr = input.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
      if (matchFr) {
        const [, dd, mm, yyyy] = matchFr
        return `${yyyy}-${mm}-${dd}`
      }

      // Format complet (yyyy-mm-dd)
      const matchFull = input.match(/^(\d{4})-(\d{2})-(\d{2})$/)
      if (matchFull) {
        return input
      }

      // Format année-mois
      const matchYearMonth = input.match(/^(\d{4})-(\d{2})$/)
      if (matchYearMonth) {
        const [, yyyy, mm] = matchYearMonth
        if (isStart) {
          return `${yyyy}-${mm}-01`
        } else {
          const lastDay = new Date(yyyy, parseInt(mm), 0).getDate() // jour 0 du mois suivant = dernier jour du mois en cours
          return `${yyyy}-${mm}-${lastDay}`
        }
      }

      // Format année
      const matchYear = input.match(/^(\d{4})$/)
      if (matchYear) {
        const yyyy = matchYear[1]
        return isStart ? `${yyyy}-01-01` : `${yyyy}-12-31`
      }

      return null
    },
    isSimpleDateFormat(input) {
      const currentYear = new Date().getFullYear()

      const formats = [
        // YYYY: Must not exceed the current year
        input => /^\d{4}$/.test(input) && parseInt(input, 10) <= currentYear,

        // YYYY-MM: Validate year and ensure the month is between 1 and 12
        input => /^\d{4}-\d{2}$/.test(input) &&
          parseInt(input.slice(0, 4), 10) <= currentYear &&
          parseInt(input.slice(5, 7), 10) >= 1 && parseInt(input.slice(5, 7), 10) <= 12,
      ]

      // Check if at least one format matches
      return formats.some(validate => validate(input))
    },
    validateDateFormat(input) {
      const currentYear = new Date().getFullYear()

      const formats = [
        // YYYY: Must not exceed the current year
        input => /^\d{4}$/.test(input) && parseInt(input, 10) <= currentYear,

        // YYYY-MM: Validate year and ensure the month is between 1 and 12
        input => /^\d{4}-\d{2}$/.test(input) &&
          parseInt(input.slice(0, 4), 10) <= currentYear &&
          parseInt(input.slice(5, 7), 10) >= 1 && parseInt(input.slice(5, 7), 10) <= 12,

        // YYYY-MM-DD: Validate year, month, and ensure the day is between 1 and 31
        input => /^\d{4}-\d{2}-\d{2}$/.test(input) &&
          parseInt(input.slice(0, 4), 10) <= currentYear &&
          parseInt(input.slice(5, 7), 10) >= 1 && parseInt(input.slice(5, 7), 10) <= 12 &&
          parseInt(input.slice(8, 10), 10) >= 1 && parseInt(input.slice(8, 10), 10) <= 31,

        // DD/MM/YYYY: Validate day, month, and year
        input => /^\d{2}\/\d{2}\/\d{4}$/.test(input) &&
          parseInt(input.slice(6, 10), 10) <= currentYear &&
          parseInt(input.slice(3, 5), 10) >= 1 && parseInt(input.slice(3, 5), 10) <= 12 &&
          parseInt(input.slice(0, 2), 10) >= 1 && parseInt(input.slice(0, 2), 10) <= 31
      ]

      // Check if at least one format matches
      return formats.some(validate => validate(input))
    },
    handleTagsChanged (newTags) {
      if (!newTags[0]) return
      // update Tag
      this.tags = newTags
      this.tag = ''
      this.$set(this.inputelement, 'chValues', newTags[0].text)
      this.emitSaveFieldValue(this.inputelement)
      // update Datepicker
      this.previousDate1 = newTags[0].text
      this.$set(this.config.end, 'minDate', this.getBoundedDate(newTags[0].text, true))
      this.date = this.getBoundedDate(newTags[0].text)
    },
    handleTags2Changed(newTags) {
      if (!newTags[0]) return
      // update Tag
      this.tags2 = newTags
      this.tag2 = '' // Hide input placeholder
      this.$set(this.inputelement, 'chValues2', newTags[0].text)
      this.emitSaveFieldValue(this.inputelement)
      // update Datepicker
      this.previousDate2 = newTags[0].text
      this.$set(this.config.start, 'maxDate', this.getBoundedDate(newTags[0].text, false))
      this.date2 = this.getBoundedDate(this.getBoundedDate(newTags[0].text, false))
    },
    onChangeDatepicker1 (selectedDates, dateStr, instance) {
      if (this.isSimpleDateFormat(this.previousDate1)) {
        this.previousDate1 = false
        return
      }
      this.date = dateStr
      const newTag = this.convertDateYmdTodmy(dateStr)
      this.tags = [{text: newTag}]
      this.tag = '' // Hide input placeholder
      this.$set(this.config.end, 'minDate', dateStr)
      this.$set(this.inputelement, 'chValues', this.date)
      this.emitSaveFieldValue(this.inputelement)
    },
    onChangeDatepicker2 (selectedDates, dateStr, instance) {
      if (this.isSimpleDateFormat(this.previousDate2)) {
        this.previousDate2 = false
        return
      }
      this.date2 = dateStr
      const newTag = this.convertDateYmdTodmy(dateStr)
      this.tags2 = [{text: newTag}]
      this.tag2 = '' // Hide input placeholder
      this.$set(this.config.start, 'maxDate', dateStr)
      this.$set(this.inputelement, 'chValues2', this.date2 ? this.date2 : '')
      this.emitSaveFieldValue(this.inputelement)
    },
    handleTagAction (action, obj, fieldKey) {
      this.hasJustAddedTag = false // Réinitialiser l'état pour handleEnterKey
      if (action === 'add') {
        const inputDate = obj.tag.text
        if (!this.validateDateFormat(inputDate)) {
          return // Exit if format is not valid
        }
        this.$set(this.inputelement, fieldKey, inputDate)
        this.emitSaveFieldValue(this.inputelement)
        obj.addTag()
      } else if (action === 'delete') {
        this.$set(this.inputelement, fieldKey, '')
        this.emitSaveFieldValue(this.inputelement)
        obj.deleteTag()
      }
    },
    changeType () {
      if (this.selected !== 'Dcompris') {
        this.$set(this.inputelement, 'chTypes', this.selected)
        this.$set(this.inputelement, 'chValues', this.date)
        this.$set(this.inputelement, 'chValues2', this.date2 ? this.date2 : '')
      } else {
        this.$set(this.inputelement, 'chTypes', 'D')
        this.$set(this.inputelement, 'chValues', this.date)
        this.$set(this.inputelement, 'chValues2', this.date2 ? this.date2 : '')
      }
      this.emitSaveFieldValue(this.inputelement)
    },
    handleEnterKey (event) {
      console.log('handleEnterKey')
      if (event.key === 'Enter') {
        if (this.hasJustAddedTag) {
          // Si l'utilisateur appuie sur Entrée une deuxième fois avec un champ vide
          if (this.tag === '') {
            // console.log('SEND');
            SKOPUS.ACTIONS.createSpinnerOverlay()
            this.$root.$emit('submit-form')
          }
        } else {
          // Lors de la première entrée, on attend que le tag soit ajouté
          // console.log('DONT SEND');
          this.hasJustAddedTag = true
        }
      }
    }
  }
}
</script>

<style>
.ops-date-input .ti-tags .ti-tag + .ti-new-tag-input-wrapper input {
  opacity: 0; /* Masque l'input lorsqu'un tag est présent */
  pointer-events: none;
}

input.datepicker-input {
  height: 40px;
  border: 1px solid #E9E9E9;
  border-radius: 6px;
  color: #222222;
  font-size: 12px;
  padding: 0 10px;
  position: absolute;
  left: 14px;
  visibility: hidden;
}
</style>

<style lang="scss" scoped>

.round-et {
  border-radius: 100%;
  font-size: 12px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  text-transform: lowercase;
  color: #ffffff;
  display: inherit;
  line-height: 40px;
  margin: 1px;
}

.ops-date-input .vue-tags-input {
  max-width: none;
}

.ops-date-input .uk-form-icon {
  border-radius: 6px;
  border: 1px solid #B8DEE6;
  background: #CEEBF2;
  color: #3782AA;
}

.ops-date-input .inputoption {
  padding: 6px 10px;
  margin-left: 15px;
  border-radius: 6px;
  border: 1px solid #B8DEE6;
  background: #CEEBF2;
  color: #3782AA;
  cursor: pointer;
  height: 34px;
}

.form-list-wrap .uk-label {
  margin: 5px 5px 7px 0;
  min-width: 100px;
}

</style>
